import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { StaffRef } from "./StaffRef";
import { useNavigate, useParams } from "react-router-dom";
import { CompaniesRef } from './CompaniesRef';
import { Company, initialCompany } from "../../../model/Companies";
import { alertOpen, AlertValue } from "../../../features/alert.slice";
import { StackedItem, StackedLists } from "../../../components/stackedLists/StackedLists";
import { StaffEditModal } from "./StaffEditModal";
import Button from "../../../components/button/Button";
import authApi from '../../../api/Auth.api';
import companiesQuery from "../../../firestore/Companies.query";
import { AuthUser, Pass, newAuthUser } from "../../../model/Auth";
import { Result } from "../../../model/Result";
import { CompaniesEditModal } from "./CompaniesEditModal";
import { UserCountList } from "../../../model/Users";
import userQuery from "../../../firestore/User.query";
import systemParametersQuery from "../../../firestore/SystemParameters.query";
import companiesApi from "../../../api/Companies.api"
import { UsersCountUpdateConfirmationModal } from "./UsersCountUpdateConfirmationModal";
import { SessionKey } from "../../../config/const";
import { Staff } from "../../../model/Staff";
import { Spiner } from "../../../components/spinner/Spiner";

export const CompaniesInfo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isDisabled = useRef(false);

  const { tenantId } = useParams<{ tenantId: string }>();

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenStaff, setIsOpenStaff] = useState(false);
  const [isOpenUsersCount, setIsOpenUsersCount] = useState(false);
  const [staffList, setStaffList] = useState<Staff[]>([]);
  const [selectStaff, setSelectStaff] = useState<Staff>();
  const [authUserAndPass, setAuthUserAndPass] = useState<AuthUser & Pass>(newAuthUser);
  const [isInfoType, setIsInfoType] = useState<"company" | "staff">("company");
  const [company, setCompany] = useState<Company>(initialCompany);
  const [afterCompany, setAfterCompany] = useState<Company>(initialCompany);
  const [isUpdateStaff, setIsUpdateStaff] = useState(false);
  const [isCSVActive, setIsCSVActive] = useState(true);
  const [isStandBy, setIsStandBy] = useState(true);
  const [beforeUsersCount, setBeforeUsersCount] = useState<number>();
  const [afterUsersCount, setAfterUsersCount] = useState<number>();
  const [isLoad, setIsLoad] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [userCountList, setUserCountList] = useState<UserCountList>({
    idRegistered: 0,
    usable: 0,
    unusable: 0,
    suspended: 0,
  });
  const [isLode, setIsLode] = useState(true);

  // 初期設定・登録後の再描画用
  useEffect(() => {
    if (tenantId) {
      const f = async () => {
        try {
          // 団体情報取得
          const company = await companiesQuery.getCompany(tenantId);
          setCompany(company);
          setBeforeUsersCount(company.usersCount)
          
          // 団体に紐づく未完了の利用者作成ステートを取得
          const state = await systemParametersQuery.getCreateState(company.id) ? true : false;
          setIsStandBy(state);

          // 登録数情報取得
          const userCountList = await userQuery.getCompanyUserCounts(company.id);
          setUserCountList(userCountList);

          // 管理者リスト取得
          const staffWithUserList = await authApi.requestGetStaff(tenantId!);
          if (staffWithUserList.success) {
            const staffList = staffWithUserList.data.filter((item: Staff) => item.email !== undefined)
            setStaffList(staffList);
          } else {
            throw new Error(staffWithUserList.data);
          }
        } catch (err: any) {
          console.error(err);
          let errorMessage = err.error;
          if (errorMessage === "ERR_NETWORK") {
            dispatch(
              alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
            );
          } else {
            dispatch(alertOpen(AlertValue(err.message, "danger")));
          }
        }
      };
      f();
    } else {
      dispatch(
        alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
      );
    }
    setIsLode(false);
  }, [dispatch, tenantId, isCSVActive, isOpen, isSubmit, isInfoType]);

  // 団体情報編集用
  // toggle
  // onSubmit
  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const toggleUsersCount = () => {
    setIsOpenUsersCount(!isOpenUsersCount);
  };
  const onClickStateChanges = async () =>{
    if(!isDisabled.current){
      try {
        isDisabled.current = true;
        await companiesQuery.changesCompaniesState(company);
        const updatedCompany = await companiesQuery.getCompany(company.id);
        dispatch(
          alertOpen(
            AlertValue(`団体を${updatedCompany.deleteFlg ? '無効' : '有効'}にしました。`, "success")
          )
        );
        isDisabled.current = false;
        navigate("/companies", {
          state: { updatedCompany },
          replace: true
        });;

      } catch (err: any) {
        console.error(err);
        dispatch(alertOpen(AlertValue("失敗しました。", "danger")));
        isDisabled.current = false;
      }
    }
  };
  const onSubmit = async (data: Company) => {
    if(!isDisabled.current){
      try {
        isDisabled.current = true;
        
        if (beforeUsersCount && afterUsersCount &&
          (beforeUsersCount !== afterUsersCount)){
            setIsLoad(true);
          // 契約数の更新前と更新後の値が存在するかつ、更新前と更新後の値が同数でない場合
          // 契約数更新API呼び出し
          const result = await companiesApi.requestUsersCountUpdate(afterUsersCount, company.id)
            .catch((reject) => {
              console.error(reject)
              setAfterUsersCount(beforeUsersCount); // 更新後の契約数を初期化
              dispatch(alertOpen(AlertValue("契約数更新処理に失敗しました。", "danger")));
              return;
            }) as {[key: string]: any};
          if (result) {
            if (result.status === 'success') {
              //更新
              await companiesQuery.queryUpdateCompanies(afterCompany);
              setBeforeUsersCount(afterUsersCount);
              dispatch(alertOpen(AlertValue("保存しました。", "success")));
              toggle();
            } else if (result.process === 'delete' && result.status === 'notDeletable') {
              setAfterUsersCount(beforeUsersCount); // 更新後の契約数を初期化
              dispatch(alertOpen(AlertValue(`未登録のID数が足りないため契約数を変更できませんでした。契約数は${result.changeUserCount}以上に設定してください。`, "danger")));
            } else {
              setAfterUsersCount(beforeUsersCount); // 更新後の契約数を初期化
              dispatch(alertOpen(AlertValue("契約数更新処理に失敗しました。", "danger")));
            }
          }
          toggleUsersCount();
          setIsLoad(false);
        } else {
          //更新
          await companiesQuery.queryUpdateCompanies(data);
          setBeforeUsersCount(data.usersCount);
          dispatch(alertOpen(AlertValue("保存しました。", "success")));
          toggle();
        }
        isDisabled.current = false;
      } catch (err: any) {
        toggleUsersCount();
        setIsLoad(false);
        setAfterUsersCount(beforeUsersCount); // 更新後の契約数を初期化
        if (err === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
          );
        } else {
          console.error(err)
          dispatch(alertOpen(AlertValue("保存に失敗しました", "danger")));
        }
        isDisabled.current = false;
      }
    }
  };

  const submitButtonClick = (data: Company) : Promise<void> => {
    setAfterUsersCount(data.usersCount);
    if (beforeUsersCount === data.usersCount) {
      onSubmit(data);
    } else {
      setAfterCompany(data);
      toggleUsersCount();
    }
    return Promise.resolve();
  }

  // 管理者詳細表示用
  const onClickStaff = (item: Staff) => {
    setIsInfoType("staff");
    setSelectStaff(item);
    const authUserAndPass: AuthUser & Pass = {
      uid: item.uid,
      photoUrl: item.photoUrl ?? '',
      displayName: item.displayName ?? '',
      email: item.email ?? '',
      tenantId: tenantId,
    }
    setAuthUserAndPass(authUserAndPass);
  };

  const onClickStaffAdd = () => {
    setIsUpdateStaff(false);
    setAuthUserAndPass(newAuthUser());
    setIsInfoType("company");
    toggleStaff();
  }

  // 管理者一覧
  const rowList: StackedItem[] = staffList.map<StackedItem>((item) => {
    // TODO: 検索のためにStateにする
    return {
      value: item,
      isSelected: item === selectStaff,
      event: () => onClickStaff(item),
    };
  });
  // メール再送
  const sendMail = async () => {
    if(!isDisabled.current){
      try {
        isDisabled.current = true;
        const result = await authApi.requestTenantSendEmail(tenantId!, selectStaff?.email!);
        if(result.success){
          dispatch(alertOpen(AlertValue("送信しました", "success")));
          isDisabled.current = false;
        } else {
          throw new Error();
        }
      } catch (err: any) {
        console.error(err)
        dispatch(alertOpen(AlertValue("送信に失敗しました", "danger")));
        isDisabled.current = false;
      }
    }
  }
  // パスワード再設定
  const resetPassword = async () => {
    await authApi.requestTenantSendPasswordResetEmail(tenantId!, selectStaff?.email!)
      .then((resp) => {
        // メール送信成功
        dispatch(
          alertOpen(AlertValue("変更メールを送信しました。", "success"))
        );
      })
      .catch((error) => {
        // メール送信失敗
        dispatch(alertOpen(AlertValue("変更メールを送信に失敗しました", "danger")));
        console.error(error);
      });
    return;
  }

  // 管理者登録・編集用
  // toggleStaff
  // onClickDeleteStaff
  // onSubmitStaff
  //
  const toggleStaff = () => {
    setIsOpenStaff(!isOpenStaff);
  };
  const onClickDeleteStaff = async () =>{
    if(!isDisabled.current){
      try {
        isDisabled.current = true;
        const authUser: AuthUser = {
          uid: selectStaff?.uid ?? '',
          photoUrl: selectStaff?.photoUrl ?? '',
          displayName: selectStaff?.displayName ?? '',
          email: selectStaff?.email ?? '',
        }
        const result: Result = await authApi.requestDeleteStaff(authUser, tenantId!);
        if (result.success) {
          dispatch(alertOpen(AlertValue("削除しました。", "success")));
          setIsInfoType("company");
          isDisabled.current = false;
        } else {
          throw new Error();
        }
      } catch (err: any) {
        let errorMessage = err.error;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
          );
        } else {
          dispatch(alertOpen(AlertValue("削除に失敗しました", "danger")));
        }
        isDisabled.current = false;
      }
    }
  };
  const onSubmitStaff = async (authUser: AuthUser & Pass) => {
    if(!isDisabled.current){
      try {
        isDisabled.current = true;

        // 登録済の管理者を取得
        const tenantStaffList = await authApi.requestGetStaff(tenantId!);
        if (!tenantStaffList.success) throw new Error("保存に失敗しました。");

        if(isUpdateStaff){
          // 更新
          authUser.uid = authUserAndPass?.uid ?? '';
          authUser.tenantId = authUserAndPass?.tenantId ?? '';

          const duplicateStaffList = tenantStaffList.data.filter((item: Staff) => item.uid !== authUser.uid && item.email === authUser.email);
          if (0 < duplicateStaffList.length) {
            // uidが異なる かつ emailが同一 の管理者が存在する場合は保存しない
            sessionStorage.setItem(SessionKey.HAS_DUPLICATED_STAFF_MAIL, "true");
            return;
          }

          // 更新処理
          const result: Result = await authApi.requestUpdateStaff(authUser, tenantId!);
          if (result.success) {
            dispatch(alertOpen(AlertValue("保存しました。", "success")));
            toggleStaff();
          } else {
            throw new Error("保存に失敗しました。");
          }
        } else {
          // 新規
          const duplicateStaffList = tenantStaffList.data.filter((item: Staff) => item.email === authUser.email);
          if (0 < duplicateStaffList.length) {
            // emailが同一 の管理者が存在する場合は保存しない
            sessionStorage.setItem(SessionKey.HAS_DUPLICATED_STAFF_MAIL, "true");
            return;
          }

          // 登録処理
          const result: Result = await authApi.requestCreateStaff(authUser, tenantId!);
          if (result.success) {
            dispatch(alertOpen(AlertValue("保存しました。", "success")));
            toggleStaff();
          } else {
            throw new Error("保存に失敗しました。");
          }
        }
        setAuthUserAndPass(authUser);
        setIsSubmit(prev => !prev);
      } catch (err: any) {
        let errorMessage = err.error;
        if (errorMessage === "ERR_NETWORK") {
          dispatch(
            alertOpen(AlertValue("ネットワークに接続できません。", "danger"))
          );
        } else {
          dispatch(alertOpen(AlertValue("保存に失敗しました", "danger")));
        }

      } finally {
        isDisabled.current = false;
      }
    }
  };

  return (
    <div className="flex h-full">
      {isOpenStaff && (<StaffEditModal
        open={isOpenStaff}
        toggle={toggleStaff}
        closeOnClickOutside={true}
        children={undefined}
        authUser={authUserAndPass}
        updateFlg={isUpdateStaff}
        onSubmit={onSubmitStaff}
      />)}
      {isOpen && (<CompaniesEditModal
        open={isOpen}
        toggle={toggle}
        closeOnClickOutside={true}
        children={undefined}
        company={company}
        updateFlg={true}
        onSubmit={submitButtonClick}
      />)}
      {isOpenUsersCount && (<UsersCountUpdateConfirmationModal
        open={isOpenUsersCount}
        toggle={toggleUsersCount}
        closeOnClickOutside={true}
        children={undefined}
        onSubmit={onSubmit}
        beforeUsersCount={beforeUsersCount}
        afterUsersCount={afterUsersCount}
        isLoad={isLoad}
      />)}
      <div className={`relative z-0 flex flex-1 ${isInfoType === "staff" ? "flex-row-reverse" : ""}`}>
        <main className="relative z-0 flex-1 w-min min-w-[520px]">
          {isLode ? <Spiner/> : (
            <article>
              <div>
                {isInfoType === "company" ? (
                  <div className={"p-6 border-r min-h-[calc(100vh-64px)]"}>
                    <CompaniesRef
                      company={company}
                      userCountList={userCountList}                   
                    />
                    <div className={'flex m-5 justify-end'}>
                      <div className={'text-gray-500'}>{isStandBy ? '【契約数更新中】' : ''}</div>
                      <Button
                        className={'ml-2'}
                        size={"sm"}
                        onClick={toggle}
                        disabled={isStandBy}
                        children={"編集"}
                      />
                      <Button
                        className={"ml-2"}
                        size={"sm"}
                        onClick={onClickStateChanges}
                        color={company.deleteFlg ? "green" : "red"}
                        disabled={isStandBy}
                        children={company.deleteFlg ? '有効にする' : '無効にする'}
                      />
                    </div>
                  </div>
                ) : (
                  <div className={"p-6 border-l min-h-[calc(100vh-64px)]"}>
                    <StaffRef value={selectStaff}/>
                    <div className={'flex justify-end'}>
                      <Button
                        color={"yellow"}
                        size={"sm"}
                        className={`ml-2 ${selectStaff?.emailVerified ? "hidden" : ""}`}
                        onClick={sendMail}
                        children={"メール再送"}
                      />
                      <Button
                        color={"green"}
                        outline
                        size={"sm"}
                        className={`ml-2 ${selectStaff?.emailVerified ? "" : "hidden"}`}
                        onClick={resetPassword}
                        children={"パスワード再設定メール送信"}
                      />
                      <Button
                        size={"sm"}
                        className={"ml-2"}
                        onClick={() => {
                          toggleStaff();
                          setIsUpdateStaff(true);
                        }}
                        children={"編集"}
                      />
                      <Button
                        color={"red"}
                        size={"sm"}
                        className={"ml-2"}
                        onClick={onClickDeleteStaff}
                        children={"削除する"}
                      />
                    </div>
                  </div>
                )}
              </div>
            </article>
          )}
        </main>
        <aside className={"w-72 p-6"}>
          {/* Breadcrumb */}
          <nav className={`flex items-start mb-6 ${isInfoType === 'company' ? "hidden" : ""}`} aria-label="Breadcrumb" >
            <div className="inline-flex items-center text-sm font-medium text-gray-900 cursor-pointer"
              onClick={() => {
                  setIsInfoType("company");
              }}>
              <ChevronLeftIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              <span>団体情報表示</span>
            </div>
          </nav>
          <Button block onClick={onClickStaffAdd}>
            管理者登録
          </Button>
          <nav
            className="min-h-0 flex-1 overflow-y-auto"
            aria-label="Directory"
          >
            <StackedLists list={rowList} />
          </nav>
        </aside>
      </div>
    </div>
  );
};
